import { render, staticRenderFns } from "./TransactionsAndServicesComponent.vue?vue&type=template&id=7cbadafd&scoped=true"
import script from "./TransactionsAndServicesComponent.vue?vue&type=script&lang=js"
export * from "./TransactionsAndServicesComponent.vue?vue&type=script&lang=js"
import style0 from "./TransactionsAndServicesComponent.vue?vue&type=style&index=0&id=7cbadafd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbadafd",
  null
  
)

export default component.exports